import React from "react";
import { getTranslations } from './Translations'

export default function FormField({ formItem, register, errors }) {
    
let translations ={};
const onFilesSelected = e => {
    
    let fileSizeLimitKB = Number.parseInt(e.currentTarget.getAttribute("maxfilesize"));
    let files = e.currentTarget.files;

    if (files.length > 0) {
        let fileSize = files[0].size;
        if (fileSize > (fileSizeLimitKB * 1024)) {
            alert(translations.errorFileTooLarge + " " + (Math.ceil(fileSizeLimitKB/1024 * 1000)/1000) + "MB");
            e.currentTarget.value = "";
            return;
        }
    }
}
const language = window?.HRMRecruitmentComponentConfiguration?.language;
translations =  getTranslations(language);

    function renderInput(formItem) {
        let requredLabel = formItem?.Validation?.required != null ? "*" : "";
        var groupCss = formItem.GroupCss + " " + (errors[formItem.BaseName]?.type === 'required' ? " invalid" : "");

        var inputProps = {
        };
          
        if (formItem.MaxLength != null && formItem.MaxLength != '')
            inputProps.maxLength = formItem.MaxLength;

        if (formItem.FileUploadMaxFileSize != null)
            inputProps.maxfilesize = formItem.FileUploadMaxFileSize;           

        switch (formItem.Type) {
            case 'fieldset':
                return (
                    <fieldset>
                        <legend>{formItem.Label}</legend>
                        {formItem.Children.map((formItem, index) => (
                            <FormField formItem={formItem} register={register} errors={errors} />
                        ))}
                    </fieldset>
                )
            case 'group':
                return (
                    <>
                        {formItem.Children.map((formItem, index) => (
                            <FormField formItem={formItem} register={register} errors={errors} />
                        ))}
                    </>
                )
            case 'row':
                return (
                    <div key={formItem.BaseName} className="form-row">
                        {formItem.Children.map((formItem, index) => (
                            <FormField formItem={formItem} register={register} errors={errors} />
                        ))}
                    </div>
                )
            case 'checkbox':
                return (
                    <div className={groupCss}>

                        <div className="form-check no-gutters">
                            <input className="form-check-input" type="checkbox" value="" id={formItem.BaseName} {...register(formItem.BaseName, formItem.Validation ?? {})} />
                            <label className={"form-check-label "+ formItem.InputCss} htmlFor={formItem.BaseName}>
                                {formItem.Label}&nbsp;{requredLabel}
                            </label>
                        </div>

                    </div>
                )
            case 'select':
                return (
                    <div className={groupCss}>
                        <label htmlFor={formItem.BaseName}>{formItem.Label}&nbsp;{requredLabel}</label>

                        <select type={formItem.Type} id={formItem.BaseName} name={formItem.BaseName} className={formItem.InputCss} {...register(formItem.BaseName, formItem.Validation ?? {})} >
                            <option></option>
                            {formItem.Options.map((item, index) => (
                                <option value={item.Id}>{item.Name}</option>
                            ))}
                        </select>
                    </div>
                )
            case 'file':
                return (
                    <div className={groupCss}>
                        <label htmlFor={formItem.BaseName}>{formItem.Label}&nbsp;{requredLabel}</label>
                        <input type={formItem.Type} onInput={onFilesSelected} id={formItem.BaseName} name={formItem.BaseName} className={formItem.InputCss} accept={formItem.FileUploadAllowedFileTypes} {...register(formItem.BaseName, formItem.Validation ?? {}, {onChange:onFilesSelected})} {...inputProps}  />
                    </div>
                )
            case 'textarea':
                return (
                    <div className={groupCss}>
                        <label htmlFor={formItem.BaseName}>{formItem.Label}&nbsp;{requredLabel}</label>
                        <textarea id={formItem.BaseName} name={formItem.BaseName} className={formItem.InputCss} {...register(formItem.BaseName, formItem.Validation ?? {})} {...inputProps} ></textarea>
                    </div>
                )
            case 'label':
                return (
                    <div className={groupCss}>
                        <label className={formItem.InputCss}>{formItem.Label}</label>
                    </div>
                )
            default:
                return (
                    <div className={groupCss}>
                        <label htmlFor={formItem.BaseName}>{formItem.Label}&nbsp;{requredLabel}</label>
                        <input type={formItem.Type} id={formItem.BaseName} name={formItem.BaseName} className={formItem.InputCss} {...register(formItem.BaseName, formItem.Validation ?? {})} {...inputProps} />
                    </div>
                )
        }
    }

    return (
        <>
            {renderInput(formItem)}
        </>
    )
}
